module.exports = __webpack_public_path__ + "img/discord.59736cd6.svg";